editDomainInfoRecord.$inject = ['domainInfo', 'auth', 'adminEntitiesApi']
import { Permissions } from '../client_auth/permissions'

export default function editDomainInfoRecord(domainInfoService, auth, adminEntitiesApi) {
  return {
    restrict: 'EA',
    scope: {
      dmDomainInfo: '='
    },
    link: function(scope) {
      scope.domainInfoRecordUI = domainInfoService.domainInfoRecordUI
      auth.hasUserOpsPermission().then(hasPermission => {
        scope.hasUserOpsPermission = hasPermission;
      });
      auth.doesUserHavePermission([Permissions.LicenseOps]).then(hasPermission => {
        scope.hasLicenseOpsPermission = hasPermission;
      });
      auth.doesUserHavePermission([Permissions.ScrambleOps]).then(hasPermission => {
        scope.hasRetentionPermission = hasPermission;
      })

      scope.saveInfo = async function() {
        scope.domainInfoRecordUI.showError = false
        scope.domainInfoRecordUI.errorMessage = null
        
        // Validate quotas are non-negative numbers
        if (scope.dmDomainInfo.toolkit_default_quotas) {
          const quotas = ['monthly_copy_quota', 'monthly_resource_download_quota', 'monthly_print_quota']
          for (const quota of quotas) {
            const value = scope.dmDomainInfo.toolkit_default_quotas[quota]
            if (value !== null && value !== undefined && (isNaN(value) || value < 0)) {
              scope.domainInfoRecordUI.showError = true
              scope.domainInfoRecordUI.errorMessage = 'All quota values must be non-negative numbers'
              scope.$apply()
              return
            }
          }
        }
        
        if (scope.dmDomainInfo.default_license_end_date) {
          const inputDate = new Date(scope.dmDomainInfo.default_license_end_date)

          // Convert the input date to midnight Hawaii time (UTC-10:00)
          // Using midnight Hawaii time to ensure the license doesn't expire before midnight for any U.S. timezones
          const hawaiiMidnight = new Date(
            inputDate.getFullYear(),
            inputDate.getMonth(),
            inputDate.getDate()
          )
          hawaiiMidnight.setUTCHours(10, 0, 0, 0) // 10:00 UTC = 00:00 Hawaii time

          scope.dmDomainInfo.default_license_end_date = hawaiiMidnight
        }
        
        const { domain_uuid, ...propsToUpdate } = scope.dmDomainInfo;

        try {
          await adminEntitiesApi.updateDomain(domain_uuid, propsToUpdate);
          scope.showDataRetentionInputs = {}
        } catch (error) {
          scope.domainInfoRecordUI.showError = true
          scope.domainInfoRecordUI.errorMessage = error.data && error.data.message ? error.data.message : 'An error occurred while saving domain info'
          scope.$apply()
        }
      }

      scope.showDataRetentionInputs = {}
      scope.editDataRetentionField = field => {
        scope.showDataRetentionInputs[field] = true
      }
      scope.getEndDate = () => {
        if (scope.dmDomainInfo && scope.dmDomainInfo.default_license_end_date) {
          return new Date(scope.dmDomainInfo.default_license_end_date)
        }
      }
      scope.defaultLicenseEndDateValid = () => {
        const endDate = scope.getEndDate()
        return endDate && endDate.getFullYear() !== 0
      }
      scope.setDate = () => {
        const endDate = scope.getEndDate()
        if (endDate && endDate.getFullYear() !== 0) {
          scope.dmDomainInfo.default_license_end_date = endDate
        }
      }
      scope.$watch('dmDomainInfo', (newDmDomainInfo, _) => {
        if (newDmDomainInfo) {
          scope.setDate()
        }
      })
    },
    template: require('./_editDomainInfoRecord.html')
  }
}
